import React from 'react'
import logo from '../Assets/newlogo.png'
import { Link } from 'react-router-dom'
function Footer() {
  return (
    <>
      <div className='footer'>
        <ul>
          <img src={logo} />
          {/* <p><i class="bi bi-geo-alt-fill"></i> Bangalore</p>
          <p><i class="bi bi-telephone-fill"></i> <a href="tel:+919632114182">+91 9632114182</a></p>
          <p><i class="bi bi-envelope-fill"></i><a href="mailto:info@professionalhouse.in">info@professionalhouse.in</a></p> */}
          <li class="flex items-center gap-2">
            <i class="bi bi-geo-alt-fill text-red-500"></i>
            <span>Bangalore</span>
          </li>

          <li class="flex items-center gap-2 ">
            <i class="bi bi-telephone-fill text-blue-600"></i>
            <a href="tel:+919632114182" class="hover:underline">+91 9632114182</a>
          </li>

          <li class="flex items-center gap-2">
            <i class="bi bi-envelope-fill text-green-600"></i>
            <a href="mailto:info@professionalhouse.in" class="hover:underline">
              info@professionalhouse.in
            </a>
          </li>
        </ul>
        <ul>
          Quick Links
          <br />
          <Link className='none' to='/'>
            <li>Home</li>
          </Link>
          {/* <Link className='none' to='/AboutUs'>
            <li>About</li>
          </Link> */}
          <Link className='none' to='/contact'>
            <li>Contact Us</li>
          </Link>
          <Link className='none' to='/terms'>
            <li>Terms and Conditions</li>
          </Link>
          <Link className='none' to='/privacypolicy'>
            <li>Privacy Policy</li>
          </Link>
          <li></li>
        </ul>
        <ul>
          Service
          <br />
          <li>Contractors</li>
          <li>Material Supplier</li>
          <li>Freelance Engineers</li>
          <li>Labours</li>
        </ul>
        <ul>
          About
          <p>
            India’s first digital construction platform connecting project owners with contractors, suppliers, and civil engineers.
          </p>
          <br />
          <p>
            Follow Us on
          </p>
          <li class="flex items-center gap-4 text-xl">
            <a href="#"><i class="bi bi-facebook text-blue-600"></i></a>
            <a href="#"><i class="bi bi-instagram text-pink-600"></i></a>
            <a href="#"><i class="bi bi-linkedin text-blue-700"></i></a>
            <a href="#"><i class="bi bi-youtube text-red-600"></i></a>
          </li>
        </ul>
      </div>
      <div className='footer-bottom'>
        <p>© Professional House – All rights reserved</p>
        <ul>
          <Link className='none' to='/terms'>
            <li>Terms and Conditions</li>
          </Link>
          <Link className='none' to='/privacypolicy'>
            <li>Privacy Policy</li>
          </Link>
        </ul>
      </div>
    </>
  )
}

export default Footer